export default __webpack_public_path__ + "static/media/ratheg2.53c7ff3f.png";